import { Link } from "react-router-dom";
import EverlastingGospelSection from "./EverlastingGospelSection";
import "../index.css";
import { motion } from "framer-motion";
import Uni from "../images/uni.jpg";
import Knock from "../images/knk.jpg";
import foot1 from "../images/foot1.jpg";
import do33 from "./img/14.jpg";
import gg3 from "../images/gg3.jpeg";
import bap from "../images/bap.jpg";
import cb from "../images/cb.jpg";
import wed from "../images/wed.jpg";
import Testimony from "./Testimony";
import StayInformed from "./StayInformed";
import WorshipWithUs from "./WorshipWithUs";
import bcsVideo from "../img/bcs.mp4";

const Home = () => {
  const sacraments = [
    { title: "Baptism", i: bap },
    { title: "Child Blessing", i: cb },
    { title: "Marriage Blessing", i: wed },
    { title: "Love Feast", i: do33 },
  ];

  const doctrines = [
    {
      title: "BCS Uniform",
      image: Uni,
      description:
        "The official uniform of the Brotherhood of the Cross and Star is white garment with cape known officially as the “soutane” in conformity with what is recorded in revelation of John the Divine...",
    },
    {
      title: "Knocking Of Head",
      image: Knock,
      description:
        "BCS members knock (bow) their head three times in reverence to the Holy Trinity God, before and after prayers or that any time, place or occasion whenever the spirit directs...",
    },
    {
      title: "Wearing Of Shoes",
      image: gg3,
      description:
        "It is the doctrine of the Brotherhood of the Cross and Star not to wear shoes into the Bethels or the house of worship, In recognition and reverence of the holiness and presence of God...",
    },
  ];

  const circleTransition = {
    duration: 0.8,
    type: "spring",
  };

  return (
    <div className="w-full bg-white overflow-x-hidden">
      {/* FULLSCREEN HERO VIDEO */}
      <section className="relative h-screen w-screen left-1/2 -translate-x-1/2 bg-black overflow-hidden">

        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover object-top"
        >
          <source src={bcsVideo} type="video/mp4" />
        </video>

        {/* DECORATIVE GLASS CIRCLES - DESKTOP */}
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 hidden md:flex gap-8 z-[999]">
          <motion.div
            initial={{ top: "-10rem", left: "4rem" }}
            whileInView={{ left: "0rem", top: "0rem" }}
            transition={circleTransition}
            className="relative w-40 h-40 md:w-56 md:h-56 lg:w-72 lg:h-72 rounded-full bg-white backdrop-blur-3xl shadow-[0_0_60px_rgba(255,255,255,0.2)] flex items-center justify-center hover:scale-110 hover:animate-pulse duration-500"
          />
          <motion.div
            initial={{ top: "0rem", left: "-4rem" }}
            whileInView={{ left: "0rem", top: "0rem" }}
            transition={circleTransition}
            className="relative w-40 h-40 md:w-56 md:h-56 lg:w-72 lg:h-72 rounded-full bg-white backdrop-blur-3xl shadow-[0_0_60px_rgba(255,255,255,0.2)] flex items-center justify-center hover:scale-110 hover:animate-pulse duration-500"
          />
          <motion.div
            initial={{ bottom: "1rem", left: "-4rem" }}
            whileInView={{ left: "0rem", top: "0rem" }}
            transition={circleTransition}
            className="relative w-40 h-40 md:w-56 md:h-56 lg:w-72 lg:h-72 rounded-full bg-white backdrop-blur-3xl shadow-[0_0_60px_rgba(255,255,255,0.2)] flex items-center justify-center hover:scale-110 hover:animate-pulse duration-500"
          />
        </div>

        {/* DECORATIVE GLASS CIRCLES - MOBILE STYLE LIKE MBHero */}
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 flex gap-6 z-[999] md:hidden">
          <motion.div
            initial={{ top: "-10rem", left: "0rem" }}
            whileInView={{ left: "0rem", top: "0rem" }}
            transition={circleTransition}
            className="w-24 h-24 pr-5 p-1.5 rounded-full bg-white backdrop-blur-3xl overflow-hidden relative hover:z-50 hover:scale-110 hover:animate-pulse duration-500 shadow-2xl"
          />
          <motion.div
            initial={{ top: "-20rem", left: "0rem" }}
            whileInView={{ left: "0rem", top: "0rem" }}
            transition={circleTransition}
            className="w-24 h-24 pr-5 p-1.5 rounded-full bg-white backdrop-blur-3xl overflow-hidden relative hover:z-50 hover:scale-110 hover:animate-pulse duration-500 shadow-2xl"
          />
          <motion.div
            initial={{ top: "-10rem", left: "0rem" }}
            whileInView={{ left: "0rem", top: "0rem" }}
            transition={circleTransition}
            className="w-24 h-24 pr-5 p-1.5 rounded-full bg-white backdrop-blur-3xl overflow-hidden relative hover:z-50 hover:scale-110 hover:animate-pulse duration-500 shadow-2xl"
          />
        </div>
      </section>

      {/* 0 MODERN EDITORIAL ABOUT SECTION */}
      <section className="bg-white pt-20 md:pt-40 pb-20 px-4 md:px-8 text-center">
        <div className="max-w-8xl mx-auto text-2xl lg:text-3xl text-stone-900">
          “And in the days of these kings shall the God of heaven set up a
          kingdom, which shall never be destroyed: and the kingdom shall not be
          left to other people, but it shall break in pieces and consume all
          these kingdoms, and it shall stand for ever.” -{" "}
          <span className="text-blue-600">Daniel 2 vs 44</span>
        </div>
      </section>

      {/* 1 MODERN EDITORIAL ABOUT SECTION */}
      <section className="bg-white pt-10 pb-20 px-4 md:px-8 border-b border-stone-100">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-20 items-stretch">
            {/* Left Column: Visual Impact */}
            <div className="lg:w-1/2 relative min-h-[600px]">
              <motion.div
                initial={{ opacity: 0, scale: 1.05 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.5, ease: [0.16, 1, 0.3, 1] }}
                className="absolute inset-0 rounded-[2rem] overflow-hidden"
              >
                <img
                  src={"/fm.jpg"}
                  alt="Universal Love"
                  className="w-full h-full object-cover object-top transition-all duration-1000"
                />
                <div className="absolute inset-0 bg-stone-900/10" />
              </motion.div>
            </div>

            {/* Right Column: Narrative */}
            <div className="lg:w-1/2 flex flex-col justify-center space-y-10 py-10">
              <div className="space-y-6">
                <div className="inline-block py-2 px-4 bg-stone-50 rounded-full">
                  <span className="text-blue-600 font-bold text-[10px] tracking-[0.2em] uppercase">
                    From 1918
                  </span>
                </div>
                <h2 className="text-5xl md:text-8xl font-bold text-stone-900 tracking-tighter leading-[0.9]">
                  The <br />
                  <span className="text-blue-600">Mission.</span>
                </h2>
              </div>

              <div className="space-y-6 max-w-lg">
                <p className="text-stone-900 text-xl md:text-2xl font-semibold leading-snug">
                  To Establish the Kingdom of God Here on Earth.
                </p>
                <p className="text-stone-500 text-lg leading-relaxed">
                  From 1918 to date, Leader Olumba Olumba Obu began His journey
                  of teaching the Everlasting Gospel to the entire world as the
                  Supernatural Teacher.
                </p>
              </div>

              <div className="flex items-center gap-10 pt-4">
                <Link
                  to="/About"
                  className="bg-stone-900 text-white px-12 py-5 rounded-full text-xs font-black tracking-[0.2em] uppercase hover:bg-blue-600 transition-all"
                >
                  Learn More
                </Link>
                <Link
                  to="/Doctrine"
                  className="group flex items-center gap-3 text-stone-900 font-bold text-xs tracking-widest uppercase"
                >
                  Our Doctrine
                  <span className="text-blue-600 group-hover:translate-x-2 transition-transform duration-300">
                    →
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2 MODERN EDITORIAL ABOUT SECTION */}
      <section className="bg-white pt-20 pb-32 px-4 md:px-8 border-b border-stone-100">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-20 items-stretch">
            {/* Left Column: Visual Impact */}
            <div className="lg:w-1/2 relative min-h-[500px]">
              <motion.div
                initial={{ opacity: 0, scale: 1.05 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.5, ease: [0.16, 1, 0.3, 1] }}
                className="absolute inset-0 rounded-[2rem] overflow-hidden"
              >
                <img
                  src={foot1}
                  alt="Universal Love"
                  className="w-full h-full object-cover transition-all duration-1000"
                />
                <div className="absolute inset-0 bg-stone-900/10" />
              </motion.div>

              {/* Overlapping Key Fact */}
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 1 }}
                className="absolute -bottom-10 -right-6 md:right-10 bg-blue-600 text-white p-10 rounded-2xl max-w-[280px]"
              >
                <div className="text-4xl font-bold mb-1">1956</div>
                <div className="text-[10px] tracking-[0.3em] font-bold uppercase opacity-70">
                  The Divine Dawn
                </div>
                <div className="mt-4 h-[1px] w-12 bg-white/30" />
                <p className="mt-4 text-sm font-medium leading-relaxed opacity-90">
                  The Kingdom of God on Earth was incorporated and officially
                  named Brotherhood of the Cross and Star.
                </p>
              </motion.div>
            </div>

            {/* Right Column: Narrative */}
            <div className="lg:w-1/2 flex flex-col justify-center space-y-10 py-10">
              <div className="space-y-6">
                <div className="inline-block py-2 px-4 bg-stone-50 rounded-full">
                  <span className="text-blue-600 font-bold text-[10px] tracking-[0.2em] uppercase">
                    About The Institution
                  </span>
                </div>
                <h2 className="text-5xl md:text-8xl font-bold text-stone-900 tracking-tighter leading-[0.9]">
                  Infinite <br />
                  <span className="text-blue-600">Oneness.</span>
                </h2>
              </div>

              <div className="space-y-6 max-w-lg">
                <p className="text-stone-900 text-xl md:text-2xl font-semibold leading-snug">
                  Transforming lives through the practice of{" "}
                  <span className="italic">Universal Love</span> and divine
                  righteousness.
                </p>
                <p className="text-stone-500 text-lg leading-relaxed">
                  The Brotherhood of the Cross and Star is a global sanctuary
                  where peace and unity flourish under the teachings of the Holy
                  Spirit.
                </p>
              </div>

              <div className="flex items-center gap-10 pt-4">
                <Link
                  to="/About"
                  className="bg-stone-900 text-white px-12 py-5 rounded-full text-xs font-black tracking-[0.2em] uppercase hover:bg-blue-600 transition-all"
                >
                  Learn More
                </Link>
                <Link
                  to="/Doctrine"
                  className="group flex items-center gap-3 text-stone-900 font-bold text-xs tracking-widest uppercase"
                >
                  Our Doctrine
                  <span className="text-blue-600 group-hover:translate-x-2 transition-transform duration-300">
                    →
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MODERN EDITORIAL DOCTRINES SECTION */}
      <section className="py-32 px-4 md:px-8 bg-stone-50 overflow-hidden">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="flex flex-col md:flex-row justify-between items-end mb-20 gap-8">
            <div className="space-y-6 max-w-2xl">
              <div className="inline-flex items-center gap-3">
                <span className="h-0.5 w-10 bg-blue-600" />
                <span className="text-blue-600 font-bold text-[10px] tracking-[0.3em] uppercase">
                  Our Core Beliefs
                </span>
              </div>
              <h2 className="text-5xl md:text-8xl font-black text-stone-900 tracking-tighter leading-none uppercase">
                Divine <br />
                <span className="text-blue-600">Principles.</span>
              </h2>
            </div>
            <p className="text-stone-500 font-medium text-lg md:text-xl max-w-sm leading-relaxed border-l-2 border-stone-200 pl-8">
              Derived from the supernatural teachings of Christ to manifest
              unity across humanity.
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-20 gap-x-12">
            {doctrines.map((item, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.1, duration: 0.8 }}
                className="group flex flex-col"
              >
                <Link
                  to="/Doctrine"
                  onClick={() => window.scrollTo(0, 0)}
                  className="block space-y-8"
                >
                  <div className="relative aspect-[4/5] overflow-hidden rounded-3xl bg-stone-200">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-all duration-1000"
                    />
                    {/* Minimal Label Overlay */}
                    <div className="absolute top-6 left-6 py-2 px-4 bg-white/90 backdrop-blur-sm rounded-full">
                      <span className="text-[10px] font-black text-stone-900 uppercase tracking-widest">
                        0{idx + 1}
                      </span>
                    </div>
                  </div>

                  <div className="space-y-4 px-2">
                    <h3 className="text-2xl font-black text-stone-900 tracking-tight uppercase group-hover:text-blue-600 transition-colors">
                      {item.title}
                    </h3>
                    <div className="h-[1px] w-12 bg-stone-200 group-hover:w-full group-hover:bg-blue-600 transition-all duration-700" />
                    <p className="text-stone-500 font-medium text-base leading-relaxed line-clamp-3">
                      {item.description}
                    </p>
                    <div className="flex items-center gap-2 pt-2 text-[10px] font-black text-stone-900 uppercase tracking-[0.2em]">
                      Explore Doctrine <span className="text-blue-600">→</span>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>

          {/* Final CTA */}
          <div className="mt-32 flex justify-center">
            <Link
              to="/Doctrine"
              className="group relative inline-flex items-center gap-4 bg-stone-900 text-white px-12 py-6 rounded-full text-xs font-black tracking-[0.3em] uppercase hover:bg-blue-600 transition-all"
            >
              The Full Doctrine
              <span className="group-hover:translate-x-2 transition-transform duration-300">
                →
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* MODERN EDITORIAL SACRAMENTS SECTION */}
      <section className="bg-white py-32 px-4 md:px-8 border-t border-stone-100">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="flex flex-col items-center text-center mb-24 space-y-6">
            <div className="inline-flex items-center gap-4">
              <span className="h-[1px] w-12 bg-blue-600" />
              <span className="text-blue-600 font-bold text-xs tracking-[0.4em] uppercase">
                Sacred Rites
              </span>
              <span className="h-[1px] w-12 bg-blue-600" />
            </div>
            <h2 className="text-5xl md:text-8xl font-black text-stone-900 tracking-tighter uppercase leading-none">
              The <span className="text-blue-600 italic">Sacraments.</span>
            </h2>
            <p className="max-w-2xl text-stone-500 font-medium text-lg md:text-xl leading-relaxed">
              Holy rites performed according to the direct manifestations of The
              Holy Spirit.
            </p>
          </div>

          {/* Creative Display: Editorial Tiles */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
            {sacraments.map((item, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.1, duration: 0.8 }}
                className="group relative"
              >
                <Link
                  to="/Sacrament"
                  onClick={() => window.scrollTo(0, 0)}
                  className="block"
                >
                  <div className="relative aspect-[3/4] overflow-hidden rounded-2xl border-b-8 border-blue-600">
                    <img
                      src={item.i}
                      alt={item.title}
                      className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-all duration-1000"
                    />
                    <div className="absolute inset-0 bg-stone-900/40 group-hover:bg-blue-900/20 transition-all duration-700" />

                    {/* Floating Label */}
                    <div className="absolute bottom-8 left-8 right-8">
                      <div className="inline-block py-1 px-3 bg-blue-600 text-white text-[9px] font-black tracking-widest uppercase mb-3">
                        Rite 0{idx + 1}
                      </div>
                      <h4 className="text-white text-2xl font-black tracking-tight leading-none uppercase">
                        {item.title}
                      </h4>
                    </div>
                  </div>

                  {/* Hover Indicator */}
                  <div className="mt-6 flex items-center justify-between px-2">
                    Explore the Sacred
                    <div className="h-px flex-1 mx-4 bg-stone-100 group-hover:bg-blue-600 transition-colors duration-500" />
                    <span className="text-blue-600 font-bold group-hover:translate-x-1 transition-transform">
                      →
                    </span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* EVERLASTING GOSPEL / EGC BOOK SECTION */}
      <EverlastingGospelSection />

      {/* Testimony section */}
      <Testimony />

      {/* Stay Informed Section */}
      <StayInformed />

      {/* Worship With Us Section */}
      <WorshipWithUs />
    </div>
  );
};

export default Home;
